import { render, staticRenderFns } from "./StatusSolucaoCombobox.vue?vue&type=template&id=5d9f4074"
import script from "./StatusSolucaoCombobox.vue?vue&type=script&lang=js"
export * from "./StatusSolucaoCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports